import httpService from "@/services/httpService";

const state = () => ({
  submitted: false,
  samples: [],
  samplesLoading: true
});

// getters
const getters = {
  submitted: (state, getters, rootState) => {
    return state.submitted;
  },
  samples: (state, getters, rootState) => {
    return state.samples;
  },
  samplesLoading: state => {
    return state.samplesLoading;
  }
};

// actions
const actions = {
  // goToNextStep({ commit, state, getters }) {
  //   commit("setStep", getters.step + 1);
  // }

  async fetchProducts({ commit }) {
    commit("setSamplesLoading", true);

    try {
      const samples = await httpService.loadProducts();
      commit("setSamples", samples);
      return samples;
    } finally {
      commit("setSamplesLoading", false);
      return false;
    }
  }
};

// mutations
const mutations = {
  setSubmitted(state, submitted) {
    state.submitted = submitted;
  },
  setSamples(state, samples) {
    state.samples = samples;
  },
  setSamplesLoading(state, loading) {
    state.samplesLoading = loading;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
